export default __webpack_public_path__ + "media/images/features/yado/tabinowa_kyushu-e7ae3f05846193bd3bde37a5b8707aa9.png";